import { Theme } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { Fragment, useContext } from "react"
import ReactDOM from "react-dom"
import { AppContext } from "Views/Home/context"
import SweetAlert from "react-bootstrap-sweetalert"
import { InitialModal } from "Methods/modal"

const useStyles = makeStyles((theme: Theme) => ({
    btnGroup: {
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: theme.spacing(4),
    },
    cancelBtn: {
        backgroundColor: "#f44336",
        color: "white",
        "&:hover": {
            backgroundColor: "#f44336",
        },
    },
    confirmBtn: {
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#4caf50",
        },
    },
    editBtn: {
        backgroundColor: "#90caf9",
        color: "white",
        "&:hover": {
            backgroundColor: "#90caf9",
        },
    },
}))
interface ComponentProps {
    title: string,
    disabled: boolean,
    modalShow: boolean,
    showEditMaterialButton?: boolean,
    confirmCallback: () => Promise<void>,
    cancelCallback?: () => void,
    editCallback?: () => void,
    children?: React.ReactNode
}
let canConfirm = true
const BoardConfirmModal = (props: ComponentProps) => {
    const {
        title,
        disabled,
        modalShow,
        confirmCallback,
        cancelCallback,
        editCallback,
        children,
        showEditMaterialButton = false,
    } = props
    const classes = useStyles()
    const { handleChangeModal } = useContext(AppContext)
    const el: HTMLElement | null = document.querySelector("#board_input_modal")
    const handleConfirm = async () => {
        if (!canConfirm) {
            return
        }
        canConfirm = false
        try {
            await confirmCallback()
            handleCancel()
            handleChangeModal({
                show: true,
                type: "success",
                title: "预约成功！",
                timeout: 800,
                customButtons: [],
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        } catch (err) {
            if (!navigator.onLine) {
                handleCancel()
                handleChangeModal({
                    show: true,
                    type: "warning",
                    customButtons: [],
                    title: "oops! 断网啦！",
                    timeout: 3000,
                    onConfirm: () => {
                        handleChangeModal(InitialModal)
                    },
                })
                return
            }
            const { response: { data = {} } = {}, message } = err
            handleCancel()
            handleChangeModal({
                show: true,
                type: "warning",
                customButtons: [],
                title: data.message || message,
                timeout: 3000,
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        }
        canConfirm = true
    }
    const handleCancel = () => {
        if (cancelCallback) {
            cancelCallback()
            canConfirm = true
        }
    }
    const handleEdit = () => {
        if (cancelCallback) {
            cancelCallback()
            canConfirm = true
        }
        if (editCallback) {
            editCallback()
            canConfirm = true
        }
    }
    return (
        <Fragment>
            {
                el && ReactDOM.createPortal(
                    <SweetAlert
                        type="default"
                        title={title}
                        confirmBtnText="确定"
                        cancelBtnText="取消"
                        disabled={disabled}
                        onConfirm={handleConfirm}
                        customButtons={
                            <span className={classes.btnGroup}>
                                <Button variant="contained" onClick={handleCancel} className={classes.cancelBtn}>
                                    取消
                                </Button>
                                <Button
                                    disabled={disabled}
                                    variant="contained"
                                    className={classes.confirmBtn}
                                    onClick={handleConfirm}
                                >
                                    确定
                                </Button>
                                { showEditMaterialButton && (
                                    <Button
                                        variant="contained"
                                        className={classes.editBtn}
                                        onClick={handleEdit}
                                    >
                                        编辑物料
                                    </Button>
                                )}
                            </span>
                        }
                        show={modalShow}
                    >
                        {children}
                    </SweetAlert>,
                    el,
                )
            }
        </Fragment>
    )
}

export default BoardConfirmModal
